<template>
 <b-card>
        <div slot="header">
            <b-row>
                <b-col cols="4">
                    <b-row>
                        <b-col cols="2" class="text-right">
                            <label>Tipo:</label>
                        </b-col>
                        <b-col cols="10">
                                <select class="custom-select mr-sm-2" id="inlineFormCustomSelect" v-model="tiponotadebito">
                                    <option :value="tipo.codigo" v-for="tipo in tiposNotaDebito" v-bind:key="tipo.codigo">
                                    {{ tipo.nombre }}
                                    </option>
                                </select>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="4">
                    <b-row>
                        <b-col>
                            <h3 class="display-">Nota de Débito Electrónica</h3>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="2">
                    <b-row>
                        <b-col>
                            <datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="2">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group
                                label-for="input_serieNC"
                                :invalid-feedback="invalidFeedback"
                                :valid-feedback="validFeedback"
                                :state="state">
                                <b-input-group prepend="F">
                                    <b-form-input
                                        :value="serieNC"
                                        @input="serieNC = $event.toUpperCase()"
                                        v-model="serieNC"
                                        maxlength="3"
                                        class="form-control"
                                        type="text"
                                        id="input_serieNC"
                                        :state="state"
                                        placeholder="Serie (*)">
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
            <b-row>
                <b-col cols="12">
                    <template v-if="generalesNC">
                        <b-alert variant="secondary" show>
                            <b-row>
                                <b-col cols="2">
                                    <b-form-group
                                            label-for="input_serieAfectada"
                                            :invalid-feedback="invalidFeedbackSerieAfectada"
                                            :valid-feedback="validFeedbackSerieAfectada"
                                            :state="stateSerieAfectada">
                                            <b-input-group size="md" prepend="F">
                                                <b-form-input :value="serieAfectada" @input="serieAfectada = $event.toUpperCase()" v-model="serieAfectada" maxlength="3" class="form-control" type="text" id="input_serieAfectada" :state="state" placeholder="Serie Afectada(*)"></b-form-input>
                                            </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="2">
                                    <input v-model="numeroAfectado" type="number" class="form-control" required placeholder="Num. Afectado">
                                </b-col>
                                <b-col cols="1">
                                    <b-row align-h="center">
                                        <b-btn v-b-modal.modal1 v-b-tooltip.hover title="Vista Previa" @click="viewPdf()" disabled><i class="fa fa-television"></i></b-btn>
                                        <b-modal id="modal1" size="lg" title="Vista Previa" cancel-title="Cerrar">
                                            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                                            <template v-else>
                                                <template v-if="pdfobject !==''">
                                                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                                                </template>
                                            </template>
                                        </b-modal>
                                    </b-row>
                                </b-col>
                                <b-col cols="7">
                                    <input v-model="descripcionNC" type="text" class="form-control" placeholder="Motivo para la Emision de la Nota de Crédito">
                                    <small v-if="checkDescripcionNC" class="form-text text-muted"><span class="text-danger">{{ responseDescripcionNC }}</span></small>
                                </b-col>
                            </b-row>

                            <b-row>

                            </b-row>
                            <br>
                        </b-alert>
                    </template>
                </b-col>
            </b-row>
            <template v-if="tiponotadebito == '011'">
                <b-row>
                    <b-col cols="5"></b-col>
                    <b-col cols="3">
                        <template v-if="validateCreditNote()">
                                <button v-if="!cargandoemisionCaso1" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Emitir</button>
                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Emitiendo</button>
                        </template>
                        <template v-else>
                            <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Emitir</button>
                        </template>
                    </b-col>
                    <b-col cols="4"></b-col>
                </b-row>
            </template>
            <template v-if="tiponotadebito == '06'">
                <b-row>
                    <b-col cols="5"></b-col>
                    <b-col cols="3">
                        <template v-if="validateCreditNote()">
                                <button v-if="!cargandoemisionCaso6" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Emitir</button>
                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Emitiendo</button>
                        </template>
                        <template v-else>
                            <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Emitir</button>
                        </template>
                    </b-col>
                    <b-col cols="4"></b-col>
                </b-row>
            </template>
            <template v-else-if="tiponotadebito == '04'">
                <br>
                <b-row>
                    <b-col cols="3">
                        <b-form-input
                            :value="monto"
                            v-model="monto"
                            class="form-control"
                            type="number"
                            id="input_monto"
                            placeholder="Monto (*)">
                        </b-form-input>
                    </b-col>
                    <b-col cols="3">
                        <b-form-input
                            disabled
                            :value="igv"
                            v-model="igv"
                            class="form-control"
                            type="number"
                            id="input_igv"
                            placeholder="Igv (*)">
                        </b-form-input>
                    </b-col>
                    <b-col cols="3">
                        <select class="custom-select mr-sm-2" v-model="afectacionIgv">
                            <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                                {{ afec.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="3">
                        <select class="custom-select mr-sm-2" v-model="especificacion">
                            <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                                {{ espec.descripcion }}
                            </option>
                        </select>
                    </b-col>
                </b-row>
                <br>
                <div class="text-center">
                    <template v-if="!ValidateCaso4()">
                        <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Emitir</button>
                    </template>
                    <template v-else>
                        <button v-if="!cargandoemisionCaso4" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Emitir</button>
                        <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                    </template>
                </div>
            </template>
            <template v-else-if="tiponotadebito == '05' || tiponotadebito == '07' || tiponotadebito == '03'">
                <template v-if="descuentoItemSiguiente">
                    <b-row>
                        <b-col cols="6">
                            <b-card border-variant="light"
                                class="text-center">
                                <template slot="header">
                                    <b-row align-v="center">
                                        <b-col cols="4"></b-col>
                                        <b-col cols="4">
                                            <h6>Items de la Factura</h6>
                                        </b-col>
                                        <b-col cols="4">
                                           <!-- <b-form-checkbox v-model="vunitario">
                                                Usar valor unitario
                                        </b-form-checkbox> -->
                                        </b-col>
                                    </b-row>
                                </template>
                                <b-row>
                                    <b-col cols="12">
                                        <template v-if="tiponotadebito == '03'">
                                            <table class="table table-boreder">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">Cantidad</th>
                                                        <th style="width: 40%">Descripcion</th>
                                                        <th style="width: 15%">Cambiar Descripcion</th>
                                                        <th style="width: 15%">V. Unitario</th>
                                                        <th style="width: 15%">V. Venta</th>
                                                        <th style="width: 10%">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listaNotaCredito" :key="index">
                                                        <td>{{ item.cantidad }}</td>
                                                        <td>{{ item.descripcion }}</td>
                                                        <td><b-input class="descuento text-center" v-model="item.cambiarDescripcion"></b-input></td>
                                                        <td>{{ item.valorUnitario }}</td>
                                                        <td>{{ item.valorVenta }}</td>
                                                        <td>
                                                            <button class="btn btn-sm btn-group btn-outline-info" @click.prevent="setrowCaso357(item, index)"><i class="fa fa-plus"></i></button>
                                                            <!-- <button v-else class="btn btn-sm btn-group btn-outline-secondary" disabled><i class="fa fa-plus"></i></button> -->
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                        <template v-else-if="tiponotadebito == '05'">
                                            <table class="table table-boreder">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">Cantidad</th>
                                                        <th style="width: 40%">Descripcion</th>
                                                        <th style="width: 15%">V. Unitario</th>
                                                        <th style="width: 15%">Descuento incl. Igv</th>
                                                        <th style="width: 15%">V. Venta</th>
                                                        <th style="width: 10%">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listaNotaCredito" :key="index">
                                                        <td>{{ item.cantidad }}</td>
                                                        <td>{{ item.descripcion }}</td>
                                                        <td>{{ item.valorUnitario }}</td>
                                                        <td><b-input class="descuento text-center" v-model="item.descuento"></b-input></td>
                                                        <td>{{ item.valorVenta }}</td>
                                                        <td>
                                                            <button class="btn btn-sm btn-group btn-outline-info" @click.prevent="setrowCaso357(item, index)"><i class="fa fa-plus"></i></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                        <template v-else-if="tiponotadebito == '07'">
                                            <table class="table table-boreder">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">Cantidad</th>
                                                        <th style="width: 15%">Descontar Cant. Prod.</th>
                                                        <th style="width: 40%">Descripcion</th>
                                                        <th style="width: 15%">V. Unitario</th>
                                                        <th style="width: 15%">V. Venta</th>
                                                        <th style="width: 10%">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listaNotaCredito" :key="index">
                                                        <td>{{ item.cantidad }}</td>
                                                        <td><b-input class="descuento text-center" v-model="item.descontarCantidad"></b-input></td>
                                                        <td>{{ item.descripcion }}</td>
                                                        <td>{{ item.valorUnitario }}</td>
                                                        <td>{{ item.valorVenta }}</td>
                                                        <td>
                                                            <button class="btn btn-sm btn-group btn-outline-info" @click.prevent="setrowCaso357(item)"><i class="fa fa-plus"></i></button>
                                                            <!-- <button v-else class="btn btn-sm btn-group btn-outline-secondary" disabled><i class="fa fa-plus"></i></button> -->
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                        <b-col cols="6">
                            <b-card border-variant="light"
                                header="Items Afectados"
                                class="text-center">
                                <b-row>
                                    <b-col cols="12">
                                        <table class="table table-boreder">
                                            <thead>
                                                <tr>
                                                    <th>Cantidad</th>
                                                    <th>Descripcion</th>
                                                    <th>Valor Unitario</th>
                                                    <th>Valor Venta</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in listaNotaCreditoAfectada" :key="`item-${index}`">
                                                    <td>{{ item.cantidad }}</td>
                                                    <td>{{ item.descripcion }}</td>
                                                    <td>{{ item.valorUnitario }}</td>
                                                    <td>{{ item.valorVenta }}</td>
                                                    <td>
                                                        <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(item, index)"><i class="fa fa-trash danger"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-col>
                                </b-row>
                                <div class="row">
                                    <div class="col-md-6 text-right">
                                        <div><strong>Total IGV:</strong></div>
                                        <div><strong>Total Venta Gravada:</strong></div>
                                        <div><strong>Total Venta Exonerada:</strong></div>
                                        <div><strong>Total Venta Inafecta:</strong></div>
                                        <div><strong>Total Venta:</strong></div>
                                    </div>
                                    <div class="col-md-6">
                                        <div>
                                            S/. {{ accumulateIgv() }}
                                        </div>
                                    <div>
                                        S/. {{ accumulateRecordedSale() }}
                                    </div>
                                    <div>
                                        S/. {{ accumulateExoneratedSale() }}
                                    </div>
                                    <div>
                                        S/. {{ accumulateUnaffectedSale() }}
                                    </div>
                                    <div>
                                         S/. {{ accumulateTotalSale() }}
                                    </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </template>
                <template>
                    <b-row>
                        <b-col cols="5"></b-col>
                        <b-col cols="4">
                            <template v-if="validateCreditNote()">
                                    <!-- Paso previo a emitir -->
                                    <template v-if="listaNotaCreditoAfectada.length == 0">
                                        <template v-if="tiponotadebito == '03'">
                                            <button v-if="!cargandoemisionCaso3" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                            <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                        </template>
                                        <template v-else-if="tiponotadebito == '05'">
                                            <button v-if="!cargandoemisionCaso5" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                            <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                        </template>
                                        <template v-else-if="tiponotadebito == '06'">
                                            <button v-if="!cargandoemisionCaso6" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                            <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                        </template>
                                        <template v-else-if="tiponotadebito == '07'">
                                            <button v-if="!cargandoemisionCaso7" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                            <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                        </template>
                                    </template>
                                    <!-- Paso para emitir -->
                                    <template v-if="listaNotaCreditoAfectada.length > 0">
                                        <template v-if="tiponotadebito == '03'">
                                            <template v-if="!caso3Emitir">
                                                <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Emitir</button>
                                            </template>
                                            <template v-else>
                                                <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteCredit()"><i class="fa fa-location-arrow"></i> Emitir</button>
                                                <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                                            </template>
                                        </template>
                                        <template v-if="tiponotadebito == '05'">
                                            <template v-if="!caso5Emitir">
                                                <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Emitir</button>
                                            </template>
                                            <template v-else>
                                                <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteCredit()"><i class="fa fa-location-arrow"></i> Emitir</button>
                                                <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                                            </template>
                                        </template>
                                        <template v-if="tiponotadebito == '07'">
                                            <template v-if="!caso7Emitir">
                                                <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Emitir</button>
                                            </template>
                                            <template v-else>
                                                <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteCredit()"><i class="fa fa-location-arrow"></i> Emitir</button>
                                                <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                                            </template>
                                        </template>
                                    </template>
                            </template>
                            <template v-else>
                                <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Siguiente</button>
                            </template>
                        </b-col>
                    </b-row>
                </template>
            </template>
            <template v-else-if="tiponotadebito == '01' || tiponotadebito == '02' || tiponotadebito == '03' || tiponotadebito == '11' || tiponotadebito == '12'">
                <h4>Proximamente...</h4>
            </template>
            <div class="w-100">
                <!-- <em class="messagetiponotadebito" v-if="tiponotadebito == '01'">Usada cuando se produce una anulación total de la venta de bienes o la anulación total o parcial de los servicios no ejecutados. La anulación de la venta o servicios no ejecutados está condicionada a la correspondiente devolución de los bienes y de la retribución efectuada, cuando corresponda.</em>
                <em class="messagetiponotadebito" v-else-if="tiponotadebito == '03'">Usada para corregir un comprobante de pago electrónico que contenga una descripción que no corresponde al bien vendido o cedido en uso o al tipo de servicio prestado.</em>
                <em class="messagetiponotadebito" v-else-if="tiponotadebito == '04'">Usada cuando se aplique descuentos a los importes totales de una factura electrónica. No se permite la emisión de notas de crédito por descuentos globales tratándose de operaciones con consumidores finales, es decir descuentos sobre boletas de venta electrónica.</em>
                <em class="messagetiponotadebito" v-else-if="tiponotadebito == '05'">Motivo a utilizarse cuando se aplique descuentos a determinado(s) ítem(s) de una factura electrónica. No se permite la emisión de notas de crédito por descuentos por ítem tratándose de operaciones con consumidores finales, es decir descuentos sobre boletas de venta electrónica.</em>
                <em class="messagetiponotadebito" v-else-if="tiponotadebito == '06'">Cuando la emisión de la nota de crédito sea para documentar la devolución de los bienes facturados.</em>
                <em class="messagetiponotadebito" v-else-if="tiponotadebito == '07'">Cuando la emisión de la nota de crédito sea para documentar la devolución de parte de los bienes facturados, inclusive una devolución de una parte de la cantidad de los bienes consignados en una línea</em> -->
            </div>
            <vue-snotify></vue-snotify>
 </b-card>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import { tiposNotaDebitoF } from '@/shared/utils'
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
export default {
    name: 'NotaDebitoBoletaEmision',
    components: {
        Datepicker
    },
    data: () => {
        return {
            indexAfectados: [],
            vunitario: false,
            emitiendo: false,
            tabIndex: 2,
            selecteditem: {},
            montoActual: '',
            montoDescuento: '',
            tipoPV: '02',
            changePrecioValor: [
                {
                    id: '01',
                    descripcion: 'Precio Unitario'
                },
                {
                    id: '02',
                    descripcion: 'Valor Unitario'
                }
            ],
            fieldsNC: [
                { key:'cantidad', label:'Cantidad'},
                { key:'descripcion', label:'Descripcion'},
                { key:'valorUnitario', label:'V. Unitario'},
                { key:'valorVenta', label:'V. Total'},
                { key:'descuento', label: 'Descuento'},
                { key:'acciones', label:'Acciones'}
            ],
            invoice: [],
            listaNotaCredito: [],
            listaNotaCreditoAfectada: [],
            descuentoItemSiguiente: false,
            generalesNC: false,
            especificacionIgv1: EspecificacionIgvTipo1,
            especificacionIgv2: EspecificacionIgvTipo2,
            modalsendnc: false,
            especificacionIgv: '01',
            afectacionIgv: '01',
            monto: '',
            igv: '',
            currentdate: '',
            es: es,
            femision: '',
            hemision: '',
            // emisioncreditnote: false,
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',
            listaafectacion: [
                {
                    id: '02',
                    descripcion: 'Inafecto'
                },
                {
                    id: '01',
                    descripcion: 'Gravado'
                },
                // {
                //     id: '03',
                //     descripcion: 'Exonerado'
                // },
                // {
                //     id: '04',
                //     descripcion: 'Exportación'
                // }
            ],
            Especificacion: [],
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            creditnotes: [],
            creditnotesinvoice: [],
            creditnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Total Gravado', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            note: {},
            CreditNote: {
                token: '',
                serie: '',
                horaEmision: '',
                tiponotadebito: '',
                montoTotalImpuestos: '',
                totalVentaGravada: '',
                sumatoriaIgv: '',
                importeTotal: '',
                descripcion: '',
                tipoMoneda: '',
                serieAfectado: '',
                numeroAfectado: '',
                tipoComprobanteAfectado: '01',
                // adicional: {
                //     "fechaVencimiento": "2019-01-20",
                //     "codigoSunatEstablecimiento": "0001"
                // },
                items: [],
                receptor: {
                    tipo: '6',
                    nro: ''
                }
            },
            items: [],
            tiposNotaDebito: tiposNotaDebitoF,
            serieAfectada: '',
            checkSerieAfectada: false,
            responseSerieAfectado: '',
            numeroAfectado: '',
            checkNumeroAfectado: false,
            responseNumeroAfectado: '',
            serieNC: '',
            checkSerieNC: false,
            responseSerieNC: '',
            descripcionNC: '',
            checkDescripcionNC: false,
            responseDescripcionNC: '',
            cargandoemisionCaso1: false,
            cargandoemisionCaso5: false,
            cargandoemisionCaso7: false,
            cargandoemisionCaso6: false,
            cargandoemisionCaso4: false,
            cargandoemisionCaso3: false,
            caso3Emitir: false,
            caso5Emitir: false,
            caso7Emitir: false,
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            checkserie: false,
            checknumero: false,
            diasnopermitidos: {
            ranges: []
            },
            tiponotadebito: '01',
            montoTotalImpuestos: '',
            sumatoriaIgv: '',
            totalVentaGravada: '',
            totalVentaExonerada: '',
            importeTotal: '',
            totalVentaInafecta: ''
        }
    },
    mounted () {
        this.initIgv(),
        this.initDates(),
        this.initNCDefault()
    },
    watch: {
        monto: function () {
            this.igv = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2)
        },
        afectacionIgv: function () {
           if(this.afectacionIgv == '01'){
               this.Especificacion = this.especificacionIgv1
               this.especificacion = {
                    codigo: '10',
                    descripcion: 'Operacion onerosa',
                    codigoTributo: '1000'
                }
           }else{
               this.Especificacion = this.especificacionIgv2
               this.especificacion = {
                    codigo: '30',
                    descripcion: 'Operación Onerosa',
                    codigoTributo: '9998'
                }
           }
        },
        tiponotadebito: function () {
            if(this.tiponotadebito == '011' || this.tiponotadebito == '03' || this.tiponotadebito == '04' || this.tiponotadebito == '05' || this.tiponotadebito == '06' || this.tiponotadebito == '07'){
                this.generalesNC = true
            }else{
                this.generalesNC = false
            }
        }
    },
    computed: {
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieNC.length == 0){

            } else if (!expreg.test(this.serieNC)) {
                return false
            } else if(this.serieNC.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieNC.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
            return this.state === true ? 'Perfecto' : ''
        },
        stateSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0){

            } else if (!expreg.test(this.serieAfectada)) {
                return false
            } else if(this.serieAfectada.length == 3 ){
                return true
            }
        },
        invalidFeedbackSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedbackSerieAfectada () {
            return this.stateSerieAfectada === true ? 'Perfecto' : ''
        }
    },
     methods: {
        ValidateCaso4: function () {
            if(this.serieNC != '' && this.serieAfectado != '' && this.numeroAfectado != '' && this.descripcionNC != '' && this.monto != '' && this.igv != ''){
                return true
            }else{
                return false
            }
        },
        accumulateIgv: function () {
            let val = 0.00;
                this.listaNotaCreditoAfectada.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val
            return val
        },
        accumulateTaxes: function () {
            var val = 0.00;
                this.listaNotaCreditoAfectada.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = val
        },
        accumulateRecordedSale: function () {
            var val = 0.00;
                this.listaNotaCreditoAfectada.forEach(function(element) {
                    if(element.montoAfectacionIgv !== 0){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaGravada = val
            return val
        },
        accumulateExoneratedSale: function () {
            var val = 0.00;
            this.totalVentaExonerada = 0
            return val
        },
        accumulateUnaffectedSale: function () {
            var val = 0.00;
                this.listaNotaCreditoAfectada.forEach(function(element) {
                    if(element.montoAfectacionIgv == 0){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaInafecta = val
            return val
        },
        accumulateTotalSale: function () {
            var val = 0.00;
            this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta
            return this.importeTotal
        },
        deleteItem: function (selected, value) {
            let item = {}
            item = selected
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    if(this.tiponotadebito == '05'){
                        item.valorUnitario = selected.oldValorUnitario
                        item.porcentajeDescuento = selected.oldPorcentajeDescuento
                        item.valorVenta = selected.oldValorVenta
                        item.baseAfectacionIgv = selected.oldBaseAfectacionIgv 
                        item.montoAfectacionIgv = selected.oldMontoAfectacionIgv
                        this.listaNotaCredito.push(item)
                        this.listaNotaCreditoAfectada.splice(value,1)
                    }else if(this.tiponotadebito == '07'){
                        item.cantidad = selected.oldCantidad
                        item.valorVenta = selected.oldValorVenta
                        item.baseAfectacionIgv = selected.oldBaseAfectacionIgv 
                        item.montoAfectacionIgv = selected.oldMontoAfectacionIgv
                        this.listaNotaCredito.push(item)
                        this.listaNotaCreditoAfectada.splice(value,1)
                    }
                }else
                {

                }
            })
        },
        setUnitValue: function () {
            let nuevoitem = this.itemAlterado
            nuevoitem.valorUnitario = this.montoDescuento / (this.$store.state.igv == 18 ? 1.18 : 1.105)
            nuevoitem.valorVenta = nuevoitem.valorUnitario * nuevoitem.cantidad
            if(this.itemAlterado.adicional == null){
                delete nuevoitem.adicional
            }
            this.listaNotaCreditoAfectada.push(nuevoitem)
        },
        initNCDefault: function () {
            this.generalesNC = false
            this.tiponotadebito = '01'
        },
        initIgv: function () {
            if(this.especificacionIgv === '01'){
                this.Especificacion = this.especificacionIgv1
            }
            else if(this.especificacionIgv === '02'){
                this.Especificacion = this.especificacionIgv2
            }
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(6,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
        validateCreditNote: function () {
            if(this.serieNC != '' && this.descripcionNC != '' && this.tiponotadebito != '0'){
                return true
            }
            else{
                return false
            }
        },
        listCreditNote: function () {
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/factura', {
                token: this.$store.getters.userToken,
                page: this.pactual,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.creditnotes = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false
                ))
            .catch(error => {})
        },
        searchInvoice: function () {
            if(this.tiponotadebito == '01'){
                this.cargandoemisionCaso1 = true
            }else if(this.tiponotadebito == '06'){
                this.cargandoemisionCaso6 = true
            }else if(this.tiponotadebito == '05'){
                this.cargandoemisionCaso5 = true
            }else if(this.tiponotadebito == '07'){
                this.cargandoemisionCaso7 = true
            }else if(this.tiponotadebito == '04'){
                this.cargandoemisionCaso4 = true
            }else if(this.tiponotadebito == '03'){
                this.cargandoemisionCaso3 = true
            }
            axios
           .post(process.env.VUE_APP_API_URL + 'facturas/obtener/detalles',{
               token: this.$store.getters.userToken,
               p: 'F' + this.serieAfectada + '-' + this.numeroAfectado,
               filtro: 'name'
           }, config)
           .then(response => (
               this.invoice = response.data.response,
               this.redirectCreditNoteTipo(response.data)
           ))
           .catch(error => {})
        },
        switchTipo: function () {
            // this.sendNoteCredit()
        },
        redirectCreditNoteTipo: function (value) {
            if(value.success == 1){
                this.listaNotaCredito = value.response.details
                if(this.tiponotadebito == '01'){
                this.cargandoemisionCaso1 = true
                this.sendNoteCredit()
                }else if(this.tiponotadebito == '03'){
                    this.cargandoemisionCaso3 = false
                    this.generalesNC = false
                    this.descuentoItemSiguiente = true
                }else if(this.tiponotadebito == '04'){
                    this.generalesNC = true
                    this.sendNoteCredit()
                }else if(this.tiponotadebito == '05'){
                    this.cargandoemisionCaso5 = false
                    this.generalesNC = false
                    this.descuentoItemSiguiente = true
                }else if(this.tiponotadebito == '06'){
                    this.cargandoemisionCaso6 = true
                    this.addItemTipo1()
                }else if(this.tiponotadebito == '07'){
                    this.cargandoemisionCaso7 = false
                    this.generalesNC = false
                    this.descuentoItemSiguiente = true
                }
            }else{
                this.$snotify.error('La Factura a la que quieres afectar no existe', 'Error'),
                this.initNCDefault(),
                this.descuentoItemSiguiente = false
            }
        },
        setNote: function (data) {
            this.note = data
        },
        sendMail: function (data) {
            this.modalsendnc = true
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito,
                mail: this.recipients
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.success(response.data.msg, 'Exito')
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           }, config)
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){

           })
        },
        addItemTipo1: function () {
            this.items = []
            let item = {}
            let nroitems = this.invoice.details.length
            for (let i = 0; i < nroitems; i++){
                item.unidadMedidaCantidad = this.invoice.details[i].unidadMedidaCantidad,
                item.cantidad = this.invoice.details[i].cantidad,
                item.valorVenta = this.invoice.details[i].valorVenta,
                item.precioVentaUnitario = this.invoice.details[i].precioVentaUnitario,
                item.tipoPrecioVentaUnitario = this.invoice.details[i].tipoPrecioVentaUnitario,
                item.montoTotalImpuestosItem = this.invoice.details[i].montoTotalImpuestosItem,
                item.baseAfectacionIgv = this.invoice.details[i].baseAfectacionIgv,
                item.montoAfectacionIgv = this.invoice.details[i].montoAfectacionIgv,
                item.porcentajeImpuesto = this.invoice.details[i].porcentajeImpuesto,
                item.tipoAfectacionIgv = this.invoice.details[i].tipoAfectacionIgv,
                item.codigoTributo = this.invoice.details[i].codigoTributo,
                item.descripcion = this.invoice.details[i].descripcion,
                item.valorUnitario = this.invoice.details[i].valorUnitario,
                item.codigoProducto = this.invoice.details[i].codigoProducto,
                item.codigoProductoSunat = this.invoice.details[i].codigoProductoSunat,
                item.descuento = this.invoice.details[i].descuento,
                item.porcentajeDescuento = this.invoice.details[i].porcentajeDescuento
                this.items.push(item)
            }
            if(this.tiponotadebito == '06'){
                this.sendNoteCredit()
            }
        },
        addItemTipo4: function () {
            let item = {}
            let nroitems = this.invoice.details.length
            for (let i = 0; i < nroitems; i++){
                item.unidadMedidaCantidad = 'NIU',
                item.cantidad = 1,
                item.valorVenta = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2),
                item.precioVentaUnitario = parseFloat(this.monto).toFixed(2),
                item.tipoPrecioVentaUnitario = this.invoice.details[i].tipoPrecioVentaUnitario,
                item.montoTotalImpuestosItem = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2),
                item.baseAfectacionIgv = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2),
                item.montoAfectacionIgv = parseFloat(this.monto - (this.monto/(this.$store.state.igv == 18 ? 1.18 : 1.105))).toFixed(2),
                item.porcentajeImpuesto = this.invoice.details[i].porcentajeImpuesto,
                item.tipoAfectacionIgv = this.invoice.details[i].tipoAfectacionIgv,
                item.codigoTributo = this.invoice.details[i].codigoTributo,
                item.descripcion = this.descripcionNC,
                item.valorUnitario = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2),
                item.codigoProducto = this.invoice.details[i].codigoProducto,
                item.codigoProductoSunat = this.invoice.details[i].codigoProductoSunat,
                item.descuento = this.invoice.details[i].descuento,
                item.porcentajeDescuento = this.invoice.details[i].porcentajeDescuento,
                this.items.push(item)
            }
            return true
        },
        setrowCaso357: function (value, i) {            
            let selected = {
                    adicional: value.adicional,
                    baseAfectacionIgv: value.baseAfectacionIgv,
                    cantidad: value.cantidad,
                    codigoProducto: value.codigoProducto,
                    codigoProductoGs1: value.codigoProductoGs1,
                    codigoProductoSunat: value.codigoProductoSunat,
                    codigoTributo: value.codigoTributo,
                    descripcion: value.descripcion,
                    descuento: value.descuento,
                    cambiarDescripcion: value.cambiarDescripcion,
                    descontarCantidad: value.descontarCantidad,
                    idFactura: value.idFactura,
                    idFacturaItem: value.idFacturaItem,
                    montoAfectacionIgv: value.montoAfectacionIgv,
                    montoTotalImpuestosItem: value.montoTotalImpuestosItem,
                    porcentajeDescuento: value.porcentajeDescuento,
                    porcentajeImpuesto: value.porcentajeImpuesto,
                    precioVentaUnitario: value.precioVentaUnitario,
                    tipoAfectacionIgv: value.tipoAfectacionIgv,
                    tipoPrecioVentaUnitario: value.tipoPrecioVentaUnitario,
                    unidadMedidaCantidad: value.unidadMedidaCantidad,
                    valorUnitario: value.valorUnitario,
                    valorVenta: value.valorVenta
                }
                if(this.tiponotadebito == '03'){
                    if(selected.cambiarDescripcion != ''){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }
                        selected.descripcion = selected.cambiarDescripcion
                        this.listaNotaCreditoAfectada.push(selected)
                        this.caso3Emitir = true
                    }else{
                        this.$snotify.warning('La descripcion no puede estar vacia', 'Cuidado')
                    }
                }
                if(this.tiponotadebito == '05'){
                    if(parseFloat(selected.descuento) < parseFloat(selected.valorUnitario)){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }
                        // valores anteriores
                        selected.oldValorUnitario = selected.valorUnitario
                        selected.oldPorcentajeDescuento = selected.porcentajeDescuento
                        selected.oldValorVenta = selected.valorVenta
                        selected.oldBaseAfectacionIgv = selected.baseAfectacionIgv
                        selected.oldMontoAfectacionIgv = selected.montoAfectacionIgv
                        // valores cambiados
                        selected.valorUnitario = value.descuento/(this.$store.state.igv == 18 ? 1.18 : 1.105)
                        selected.porcentajeDescuento = (selected.valorUnitario * 100) / value.valorUnitario
                        selected.valorVenta = selected.valorUnitario * selected.cantidad
                        selected.baseAfectacionIgv = selected.valorVenta
                        if(selected.montoAfectacionIgv == 0){
                            selected.montoAfectacionIgv = 0
                        }else{
                            selected.montoAfectacionIgv = selected.baseAfectacionIgv *(this.$store.state.igv == 18 ? 0.18 : 0.105)
                        }
                        this.listaNotaCreditoAfectada.push(selected)
                        this.listaNotaCredito.splice(i,1)
                        this.caso5Emitir = true
                    }else{
                        this.caso5Emitir = false
                        this.$snotify.warning('El descuento no puede ser mayor al Valor Unitario', 'Cuidado')
                    }
                }
                if(this.tiponotadebito == '07'){
                    if(parseFloat(selected.descontarCantidad) <= parseFloat(selected.cantidad)){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }
                        // valores anteriores
                        selected.oldCantidad = selected.cantidad
                        selected.oldValorVenta = selected.valorVenta
                        selected.oldBaseAfectacionIgv = selected.baseAfectacionIgv
                        selected.oldMontoAfectacionIgv = selected.montoAfectacionIgv
                        // valores cambiados
                        selected.cantidad = value.descontarCantidad
                        selected.valorVenta = selected.cantidad * selected.valorUnitario
                        selected.baseAfectacionIgv = selected.valorVenta
                        if(selected.montoAfectacionIgv == 0){
                            selected.montoAfectacionIgv = 0
                        }else{
                            selected.montoAfectacionIgv = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105)
                        }
                        this.listaNotaCreditoAfectada.push(selected)
                        this.listaNotaCredito.splice(i,1)
                        this.caso7Emitir = true
                    }else{
                        this.caso7Emitir = false
                        this.$snotify.warning('La cantidad ingresada no puede ser mayor a la actual', 'Cuidado')
                    }
                }
        },
        sendNoteCredit: function () {
            this.emitiendo = true
            this.CreditNote.token = this.$store.getters.userToken
            if(this.femision != ''){
                this.CreditNote.fechaEmision = this.femision
            }
            this.CreditNote.serie = 'F' + this.serieNC
            this.CreditNote.tiponotadebito = this.tiponotadebito
            this.CreditNote.montoTotalImpuestos = this.invoice.montoTotalImpuestos
            this.CreditNote.totalVentaGravada = this.invoice.totalVentaGravada
            this.CreditNote.sumatoriaIgv = this.invoice.sumatoriaIgv
            this.CreditNote.importeTotal = this.invoice.importeTotal
            this.CreditNote.descripcion = this.descripcionNC
            this.CreditNote.tipoMoneda = this.invoice.tipoMoneda
            this.CreditNote.serieAfectado = 'F' + this.serieAfectada
            this.CreditNote.numeroAfectado = this.numeroAfectado
            this.CreditNote.receptor.nro = this.invoice.idReceptor
            if(this.tiponotadebito == '01'){
                this.addItemTipo1()
                this.CreditNote.items = this.items
            }else if(this.tiponotadebito == '03'){
                 this.addItemTipo1()
                this.CreditNote.items = this.listaNotaCreditoAfectada
            }else if(this.tiponotadebito == '04'){
                if(this.addItemTipo4()){
                    this.CreditNote.montoTotalImpuestos = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2),
                    this.CreditNote.totalVentaGravada = parseFloat(this.monto / 0.82).toFixed(2),
                    this.CreditNote.sumatoriaIgv = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2),
                    this.CreditNote.importeTotal = parseFloat(this.monto).toFixed(2),
                    this.CreditNote.descripcion = this.descripcionNC,
                    this.CreditNote.tipoMoneda = this.invoice.tipoMoneda,
                    this.CreditNote.serieAfectado = 'F' + this.serieAfectada,
                    this.CreditNote.numeroAfectado = this.numeroAfectado,
                    this.CreditNote.receptor.nro = this.invoice.idReceptor
                    this.CreditNote.items = this.items
                }
            }else if(this.tiponotadebito == '05' || this.tiponotadebito == '07'){
                this.CreditNote.sumatoriaIgv = this.accumulateIgv()
                this.CreditNote.montoTotalImpuestos = this.accumulateIgv()
                this.CreditNote.totalVentaGravada = this.accumulateRecordedSale()
                this.CreditNote.totalVentaExonerada = this.accumulateExoneratedSale()
                this.CreditNote.totalVentaInafecta = this.accumulateUnaffectedSale()
                this.CreditNote.importeTotal = this.accumulateTotalSale()
                this.CreditNote.items = this.listaNotaCreditoAfectada
            }else if(this.tiponotadebito == '06'){
                this.CreditNote.items = this.items
            }
            axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/emitir', this.CreditNote, config)
           .then(response => (
               this.cargandoemisionCaso1 = false,
               this.cargandoemisionCaso5 = false,
               this.cargandoemisionCaso7 = false,
               this.cargandoemisionCaso6 = false,
               this.cargandoemisionCaso4 = false,
               this.cargandoemisionCaso3 = false,
               this.caso3Emitir = false,
               this.caso5Emitir = false,
               this.caso7Emitir = false,
               this.descuentoItemSiguiente = false,
               this.items = [],
               this.listaNotaCredito = [],
               this.listaNotaCreditoAfectada = [],
               this.serieNC = '',
               this.serieAfectada = '',
               this.numeroAfectado = '',
               this.descripcionNC = '',
               this.monto = '',
               this.igv = '',
               this.tiponotadebito == '01',
               this.changeTab(3),
               this.tabIndex = 3,
               this.emitiendo = false,
               this.$snotify.success(response.data.msg, 'Exito'),
               this.initNCDefault(),
                this.descuentoItemSiguiente = false,
                this.CreditNote = {
                   token: '',
                    serie: '',
                    horaEmision: '',
                    tiponotadebito: '',
                    montoTotalImpuestos: '',
                    totalVentaGravada: '',
                    sumatoriaIgv: '',
                    importeTotal: '',
                    descripcion: '',
                    tipoMoneda: '',
                    serieAfectado: '',
                    numeroAfectado: '',
                    tipoComprobanteAfectado: '01',
                    items: [],
                    receptor: {
                        tipo: '6',
                        nro: ''
                    }
               }
           ))
           .catch(error => (
                this.$snotify.error(error.response.data.response.message, 'Error'),
                this.cargandoemisionCaso1 = false,
                this.cargandoemisionCaso5 = false,
                this.cargandoemisionCaso7 = false,
                this.cargandoemisionCaso6 = false,
                this.cargandoemisionCaso4 = false,
                this.cargandoemisionCaso3 = false,
                this.caso3Emitir = false,
                this.caso5Emitir = false,
                this.caso7Emitir = false,
                this.emitiendo = false,
                this.initNCDefault(),
                this.descuentoItemSiguiente = false
            ))
        },
         customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        }
    }
}
</script>

<style>
    .cabecera {
        margin-top: 15px;
    }
    .espacio {
        margin-left: 15px;
    }
    .messagetiponotadebito {
        color: #8d8d8d;
        font-size: 11px;
    }
    .input-requerido {
        color:red;
        opacity: 0.7;
    }
    .descuento {
        background-color: #ccffff;
    }
    .serieNC {
        padding-top: 15px;
    }
</style>


